import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pCore, rCore } from '../../models/.catalog';

export default class OturumKapatApi extends ApiBase<pCore, rCore> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OturumKapat',
      }),
      options
    );
    this._ServiceUrl = '/services/Kullanici.asmx';
  }
}
